import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraFormField, SpecraInlineBanner, SpecraInput, SpecraOverlayDialog } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { useSplitSeat } from '../hooks/useLandscapeSeats';
export function SplitSeatDialog({ seat, onClose }) {
    const [name, setName] = useState('');
    const [date, setDate] = useState('');
    const [error, setError] = useState('');
    const split = useSplitSeat();
    const submit = async ()=>{
        if (!name.trim() || !date) {
            setError('New seat name and split date are required.');
            return;
        }
        try {
            await split.mutateAsync({
                seatId: seat.id,
                newName: name.trim(),
                splitOn: date
            });
            onClose();
        } catch (e) {
            setError(e instanceof Error ? e.message : String(e));
        }
    };
    return /*#__PURE__*/ _jsxs(SpecraOverlayDialog, {
        open: true,
        title: `Split ${seat.name}`,
        testId: Testids.seatAdmin.splitDialog,
        onOpenChange: (v)=>{
            if (!v) onClose();
        },
        footerProps: {
            cancelLabel: 'Cancel',
            onCancel: onClose,
            confirmLabel: 'Split seat',
            onConfirm: submit,
            loading: split.isPending
        },
        children: [
            error && /*#__PURE__*/ _jsx(SpecraInlineBanner, {
                tone: "danger",
                "data-testid": Testids.seatAdmin.error,
                children: error
            }),
            /*#__PURE__*/ _jsx(SpecraFormField, {
                label: "New seat name",
                htmlFor: "split-name",
                required: true,
                children: /*#__PURE__*/ _jsx(SpecraInput, {
                    id: "split-name",
                    value: name,
                    onChange: (e)=>setName(e.target.value)
                })
            }),
            /*#__PURE__*/ _jsx(SpecraFormField, {
                label: "Split date",
                htmlFor: "split-date",
                required: true,
                children: /*#__PURE__*/ _jsx(SpecraInput, {
                    id: "split-date",
                    type: "date",
                    value: date,
                    onChange: (e)=>setDate(e.target.value)
                })
            })
        ]
    });
}
